import * as angular from 'angular';
import {SerfWebAdmin} from './admin/admin.module';
import {SerfWebAnlaufstelleverwaltung} from './anlaufstelleverwaltung/anlaufstelleverwaltung.module';
import {SerfWebAuthentication} from './authentication/authentication.module';
import {SerfWebBenutzerverwaltung} from './benutzerverwaltung/benutzerverwaltung.module';
import {SerfWebCore} from './core/core.module';
import {SerfWebGesuch} from './gesuch/gesuch.module';
import {SerfWebInspektoratverwaltung} from './inspektoratverwaltung/inspektoratverwaltung.module';
import {SerfWebSchadenfaelle} from './schadenfaelle/schadenfaelle.module';
import {SerfWebStatistik} from './statistik/statistik.module';
import {SerfWebTestpage} from './testpage/testpage.module';
import SerfWebversicherungsbeitraege from './versicherungsbeitraege/versicherungsbeitraege.module';
import {SerfWebZahlungen} from './zahlungen/zahlungen.module';
import SerfWebCockpit from './cockpit/cockpit.module';

const dependencies: string[] = [
    /* Angular modules */

    /* shared DVBern modules */
    SerfWebCore.name,
    SerfWebAdmin.name,
    SerfWebAuthentication.name,
    SerfWebTestpage.name,
    SerfWebSchadenfaelle.name,
    SerfWebBenutzerverwaltung.name,
    SerfWebAnlaufstelleverwaltung.name,
    SerfWebZahlungen.name,
    SerfWebversicherungsbeitraege.name,
    SerfWebStatistik.name,
    SerfWebGesuch.name,
    SerfWebInspektoratverwaltung.name,
    SerfWebCockpit.name,

    /* 3rd-party modules */
    'ui.bootstrap',
];

export default angular.module('serfWeb', dependencies);




// WEBPACK FOOTER //
// ./src/app/app.module.ts